//Declare app level module which depends on filters, and services
// require('../services/jv.services.js');
require('../../common/angajaxservice.js');
require('../../jhire/jv.directives.webpack.js');
require('../../common/totango/jv.totango.js');
require('../../common/jv.Filters.webpack.js');
require('../../jhire/services/jv.Hire.Url.Service.js');
require('../../common/jv.TextUtil.js');
require('../../jhire/services/jv.Hire.Broadcast.Service.js');
angular.module('jv', ['jv.services', 'jv.directives', 'ui', 'jv.log4javascript', 'jv.totango', 'ngRoute', 'ngSanitize', 'jv.Common.Filters', 'jv.Hire.Url.Service','jv.Common.TextUtil','jv.Hire.Broadcast.Service'])
    .config(['$httpProvider', function($httpProvider){
        /**
         * This interceptor will take care of readMode appending to URL.
         * We will have to make this more robust, but the idea is that any of the readMode flags are
         * set and the request is a POST operation, it should append the readMode=0 if not already appended.
         * Eventually we will need to make this robust enough for GET calls as well.
         * Will tackle the GET calls little later after discussing with the team.
         */
        $httpProvider.interceptors.push(['$q', '$rootScope', function($q, $rootScope) {
            return {
            'request': function(config) {
                if (config.method === 'POST') {
                    var readMode = $rootScope.readMode || (angular.isDefined($rootScope.fastRead) && $rootScope.fastRead.summary) || $rootScope.fastReadOn;
                    if (readMode) {
                        //If the URL already has readMode, ignore it.
                        if (angular.isDefined(config.url) && config.url.indexOf('readMode=') === -1) {
                            if (config.url.indexOf('?') !== -1) {
                                config.url += '&readMode=0';
                            } else {
                                config.url += '?readMode=0';
                            }
                        }
                    }
                }
               return config;
            }
          };
        }]);

    $httpProvider.interceptors.push(['$rootScope', '$q', function($rootScope, $q){
        return {
            response: function(response) {
                if (response.data && response.data.msgInfo) {
                    response.status = response.data.msgInfo;
                }
                return response;
            },
            responseError: function(response) {
                switch (response.status) {
                    case 401:
                        self.location = window.jvUrls.forum + 'Login/Login.aspx?ReturnUrl=' + self.location;
                        break;
                    case 403:
                        if(response.data) {
                            //when any URL returns 403 and if the response has url to be redirected,
                            //the below code redirects main page url to the given url.
                            if(response.data.accessDeniedRedirectUrl) {
                                self.location = window.jvUrls.admin + response.data.accessDeniedRedirectUrl;
                            }
                        }
                        break;
                    default:
                        // Dirty quickfix for 9077 untill BE come up with their fix
                        if (response.status >= 400 && response.status < 409) {
                            $rootScope.error = i18n.UNABLE_TO_PERFORM_OPERATION;
                        }
                }
                if(response.data && response.data.error_message) {
                    if(response.data.error_message.indexOf('HR_Restricted') > -1) {
                        $rootScope.error = 'This requisition has required fields that must be completed by Human Resources before it can be posted or submitted for approval';
                    }
                }
                $rootScope.flags.loading = false;
                return $q.reject(response);
              }
        };
    }]);
}]).run(['$rootScope', '$timeout', '$routeParams', 'KeepAlive', '$filter', 'uiTemplateSelect2FAC', function($rootScope, $timeout, $routeParams, KeepAlive, $filter, uiTemplateSelect2FAC){
    /**
     * Stores different states and flags of the current page
     */
    $rootScope.flags = {};
    /**
     * Controls page-wide loading overlay
     */
    $rootScope.flags.loading = true;
    $rootScope.$on('$routeChangeStart', function(){
        $rootScope.flags.loading = true;
    });
    /**
     * This variable is the backing ng:model of the form elements, will be subjected to some processing before the form is submitted.
     */
    $rootScope.result = {};
    /**
     * Scope storage for internationalization
     */
    if (typeof i18n === 'undefined')
        i18n = {};
    $rootScope.i18n = i18n;

    /**
     * Permissions passed inline from backend
     * @type {object}
     */
    if (typeof views === 'undefined'){
        $rootScope.perms = window.views || {};
    }
    //status object for all requests.
    $rootScope.status = {
            OK          : 200,
            BAD_REQUEST : 400
    };
    /**
     * Holds the forumBaseUrl
     */
    $rootScope.forumBaseUrl='';
    $rootScope.jvUrls = window.jvUrls;

    /**
     * Scope storage for route params
     *
     * @example: $rootScope.params = $routeParams;
     */
    $rootScope.params = $routeParams;
    // Adds ?param=value to $rootScope.params
    function supplementParams(){
        var params = window.location.search.substr(1);
        if (!params)
            return;
        params = params.split('&');
        angular.forEach(params, function(param){
            param = param.split('=');
            // If the hash doesn't exist, add the param
            if ($routeParams[param[0]] === undefined && param[1]) {
                $routeParams[param[0]] = unescape(param[1].replace(/\+/g, ' '));
            }
        });
    }
    supplementParams();
    $rootScope.$on('$routeChangeSuccess', function(){
        supplementParams();
    });
    /**
     * Modal dialogue helper
     * If an array is stored under the buttons attribute, it will be used instead.
     */
    $rootScope.modal = {
            show: false, // {boolean}
            title: '',
            body: '',
            ok: angular.noop,
            cancel: angular.noop,
            buttons: false, /* or [
            { label: 'Save', href: 'example.com', click: someCallback, class: 'left', title: 'Click to save' },
            { label: 'Exit', href: 'example.com', click: someCallback, class: 'left' }
        ] */
            form: false /* or {
            to: 'string' (readonly) || false (editable),
            // result data will go into:
            cc: [],
            subject: '',
            content: ''
        } */
    };

    /**
     * Removes any non-whitelisted attributes and returns a new object
     * @param  {object} data  The data
     * @param  {array}  keys  List of allowed attributes
     * @return {object}       New whitelisted object
     */
    $rootScope.whitelist = function(data, keys) {
        var newObject = {};
        angular.forEach(keys, function(key){
            if (data[key] !== undefined) {
                newObject[key] = data[key];
            }
        });
        return newObject;
    };

    /**
     * A replacement utility for internationalization very similar to sprintf.
     *
     * @param replace {mixed} The tokens to replace depends on type
     *  string: all instances of $0 will be replaced
     *  array: each instance of $0, $1, $2 etc. will be placed with each array item in corresponding order
     *  object: all attributes will be iterated through, with :key being replaced with its corresponding value
     * @return string
     *
     * @example: 'Hello :name, how are you :day'.format({ name:'John', day:'Today' })
     * @example: 'Records $0 to $1 out of $2 total'.format(['10', '20', '3000'])
     * @example: '$0 agrees to all mentions $0 makes in the event that $0 hits a tree while $0 is driving drunk'.format('Bob')
     */
    $rootScope.format = function(target, replace) {
        var token;
        if (replace === undefined) {
            return target;
        }
        if (!angular.isArray(replace) && !angular.isObject(replace)) {
            return target.split('$0').join(replace);
        }
        token = angular.isArray(replace) && '$' || ':';

        angular.forEach(replace, function(value, key){
            target = target.split(token+key).join(value);
        });
        return target;
    };

    /* @Written By - Abilash
     * @function: $rootScope.sortObjByKey
     * @params: Target - Object To Sorted By Key Which Has Keys As Numbers
     * @returns - Object - Sorted By Keys
     * @Description - Sometimes, BE sends the data which is unsorted by keys, as in the case of Application By Source Pie Chart.
     *                Chrome sorts each BE JSON by key, but firefox doesn't. So this method will sort the object by key and returns the sorted object
     */
    $rootScope.sortObjByKey = function(target) {
        var tempData = [];
        var tempObj = {};
        for(var data in target){
            tempData.push(parseInt(data));
        }
        tempData.sort(function (a,b) { return a - b; });
        for(var sorted in tempData) {
            tempObj[tempData[sorted]] = target[tempData[sorted]];
        }
        return tempObj;
    };

    /**
     * Extracts properties of an array of objects and returns an array of strings
     * Similar to _.js 'pluck' method
     *
     * @TODO Make paths go deeper than 1 level
     * @TODO Allow an array for separator param?
     * @param paths {mixed} the property to retrieve from the objects
     *   string: property name
     *   array[string]: array of property names to be joined by separator in the order passed
     * @param [separator] {string} Optional the string to join multiple properties
     *
     * @example [{name:'Dean'},{name:'Sofer'}].extract('name') => ['Dean', 'Sofer']
     * @example [{first:'Dean',last:'Sofer'}, {first:'Bob',last:'Saget'}].extract(['last','first'], ' - ') => ['Sofer - Dean', 'Saget - Bob']
     * @example [{name:{first:'Dean',last:'Sofer'}}].extract(['name.first','name.last'], ' ') => ['Dean Sofer']
     */
    $rootScope.extract = function(value, paths, separator) {
        var result = [],
        newItem;
        if (angular.isArray(value) || angular.isObject(value)) {
            angular.forEach(value, function(item) {
                // Cast string to an array
                if (angular.isString(paths))
                    paths = [paths];
                newItem = [];
                angular.forEach(paths, function(path){
                    // Traverse object depths based on object-notation
                    var parts = path.split('.'), thisDepth = item;
                    for (var i = 0; i < parts.length; i++) {
                        thisDepth = thisDepth[parts[i]];
                        if (i === parts.length - 1)
                            newItem.push(thisDepth);
                    }
                });
                newItem = newItem.join(separator);
                result.push(newItem);
            });
        } else {
            result = value;
        }
        return result;
    };

    /* ===========================================================================
        dateISO8601
        * Returns an ISO8601 version of a date
        *
        * @param <String>  date // '5/12/14'
        * @return <string> date // '2011-12-19T15:28:46.493Z'
        ========================================================================== */
    //
    $rootScope.dateISO8601 = function(date) {
        var tempDate = new Date(date);
        return tempDate.toISOString();
    };

    $rootScope.getTodayDateUserTimezone = function() {
        var userTimeZone = window._jvselfUser.locale.timezone;
        var todayDate = new Date( moment.tz(new Date(),userTimeZone).format('MM/DD/YYYY') );
        return todayDate;
    };

    /**
     * Checks containerArr which is an array of objects to see if obj exists in it.
     */

    $rootScope.holds = function(containerArr,obj){
        var result;
        for(var i =0 ; i< containerArr.length; i++){
                if(angular.equals(obj, containerArr[i])){
                    result = true;
                    break;
                }else{
                    result = false;
                }
        }
        return result;
    };

    /**
     * Method to normalize date
     * Input : date in ms
     * Output : 'Month dd, yyyy hh:mm:ss'
     */
    $rootScope.normalizeDates = function(dateVal){
        var d = new Date(dateVal);
        var dateStr = $filter('date')(d, 'MMMM')+' '+d.getDate()+', '+d.getFullYear()+' '+d.getHours()+':'+$filter('date')(d, 'mm')+':'+$filter('date')(d, 'ss');
        return dateStr;
    };

    /**
     * Method to get milliseconds
     */
    $rootScope.getMilliseconds = function(dateVal){
        if(dateVal){
            var d = new Date(dateVal);
            return d.getTime();
        }
    };

    /**
     * Method used to ellipsis the text
     * @param item : item which need to be ellipse
     * @param limit : Default 10. limit for the ellipse
     * @returns ellipsed string
     */
    $rootScope.ellipsis = function(item,limit){
        if(!item) return;
        limit =  limit || 10;
        return item.length > limit ? item.substring(0,limit)+'...' : item;
    };

    /**
     * Caching mechanism for ng-include. Once expression becomes true, the path will no longer change.
     * This prevents Angular from removing the contents of ng:include when the expression becomes false
     *
     * @param expression {boolean}
     * @param path {string} url to use if expression is true
     */
    var includes = {};
    $rootScope.inc = function(expression, path) {
        if (expression || includes[path]) {
            includes[path] = true;
            return path;
        }
    };

    /**
     * Expand or contract all items in a dataset
     * Sets the item.expanded attribute to true or false
     *
     * @param dataset {Array} Array of objects to modify
     * @param [expand] {boolean} true to expand, false to contract
     */
    $rootScope.expandAll = function(dataset, expand) {
        if (expand === undefined) {
            expand = true;
        }
        angular.forEach(dataset, function(item, index){
            item.expanded = expand;
        });
    };

    /**
     * Highlights the active tab (styling only atm)
     * Checks if the path passed matches the current path ignores REST params
     *
     * @todo add code to ignore REST params. ToDo: Use $location.path
     * @returns {boolean}
     */
    $rootScope.activeTab = function(url){
        return (window.location.hash.indexOf(url) !== -1);
    };

    /**
     * Fetch today's date in user's timezone.
     */
    $rootScope.fetchTodayInUsersTimeZone = function() {
        var userTimeZone = window._jvselfUser.locale.timezone;
        var todayDate = new Date( moment.tz(new Date(),userTimeZone).format('MM/DD/YYYY') );
        return todayDate;
    };

    /**
     * Updates the login link after the header is loaded
     */
    $rootScope.header = function() {
        $('#Login').attr('href', '../../logout.html');
    };

    /**
     * Unescapes the passed html (useful for doubly escaped content)
     * DO-NOT-USE: This is XSS prone solution. It executes the text. We need to get rid of this. 
     * @param text {string}
     */
    $rootScope.unescape = function(text) {
        if (text) {
            return $('<div />').html(text).text();
        } else {
            return text;
        }
    };

    /*Stripping '\n' from the content which contains HTML before posting to BE
        We want HTML to be posted as a single string so that we avoid replacing
        the \n when we get it from BE
    http://screencast.com/t/mFcdLYFxOa*/
    $rootScope.stripNewLines = function(content){
        if(content){
            content = content.replace(/\n/ig, '');
        }
        return content;
    };

    /**
     * dateDiff used to get the difference between two dates
     * @param date1 {string} : one of the date
     * @param date2 {string} : another date
     * @param type  {string} : diff type . like days , years .etc
     * @returns difference between two dates.
     */
    $rootScope.dateDiff = function(date1,date2,type){
        var second=1000, minute=second*60, hour=minute*60, day=hour*24, week=day*7;
        date1 = new Date(date1);
        date2 = new Date(date2);
        var timediff = date2 - date1;
        if (isNaN(timediff)) return 0;
        switch (type) {
            case 'years': return date2.getFullYear() - date1.getFullYear();
            case 'months': return (
                    ( date2.getFullYear() * 12 + date2.getMonth() )
                    -
                    ( date1.getFullYear() * 12 + date1.getMonth() )
            );
            case 'weeks'  : return Math.floor(timediff / week);
            case 'days'   : return Math.ceil(timediff / day);
            case 'hours'  : return Math.floor(timediff / hour);
            case 'minutes': return Math.floor(timediff / minute);
            case 'seconds': return Math.floor(timediff / second);
            default: return Math.floor(timediff / second);
        }
    };

    /**
     * Checks an object-literal of arrays to see if the key exists, and if so returns that array
     * Otherwise, iterates through all keys and merges their arrays together.
     *
     * @param dataset {Object-Literal} Object literal of arrays to look through
     * @param key {string} key to use for checkup on the object literal
     * @return array
     */
    $rootScope.subsetArrays = function(dataset, key, force) {
        var allItems = [];
        if (key && dataset[key]) {
            return dataset[key];
        } else {
            angular.forEach(dataset, function(section){
                allItems = allItems.concat(section);
            });
            return allItems;
        }
    };

    /**
     * Filters out all duplicate items from an array by checking the specified key
     *
     * @param items {array} Array of objects to check
     * @param key {string} the name of the attribute of each object to compare for uniqueness
     * @return {array}
     */
    $rootScope.uniqueArray = function(items, key) {
        var value, hashCheck = {},
        results = [];
        for (var i in items) {
            value = items[i][key];
            if (!hashCheck[value]) {
                hashCheck[value] = true;
                results.push(items[i]);
            }
        }
        return results;
    };

    $rootScope.isIE = function(){
        var agent = window.navigator.userAgent;
        if(agent && (((agent.toLowerCase()).indexOf('msie') > -1) || ((agent.toLowerCase()).indexOf('edge') > -1) || !!agent.match(/Trident.*rv:([0-9]{1,}[\.0-9]{0,})/))){
            return true;
        }else{
            return false;
        }
    };

    function checkIEVersion(){
        if ((navigator.appVersion.indexOf('MSIE 7.')!==-1)){
            return 7;
        }else if((navigator.appVersion.indexOf('MSIE 8.')!==-1)){
            return 8;
        }else if((navigator.appVersion.indexOf('MSIE 9.')!==-1)){
            return 9;
        }else{
            //returning modern incase of other browsers
            return 'modern';
        }
    }
    $rootScope.IEVersion = checkIEVersion();

    /**
     * Wrapper for angular.isArray, isObject, etc checks for use in the view
     *
     * @param type {string} the name of the check (casing sensitive)
     * @param value {string} value to check
     */
    $rootScope.is = function(type, value) {
        return angular['is'+type](value);
    };

    /**
     * Wrapper for $.isEmptyObject()
     *
     * @param value {mixed} Value to be tested
     * @return boolean
     */
    $rootScope.empty = function(value) {
        return $.isEmptyObject(value);
    };

    /**
     * Checks if any form elements are in a dirty(edited) state.
     *
     * @param parent check for ng-dirty elements under this specific parent. Parent can be an array(multiple) or a string(single).
     * @return String Message that is displayed to the user on a default browser prompt.
     *
     */
    $rootScope.navAway = function(parent, showConfirm) {
        var dirtyElms, navAway = false, eachParent;
        if(parent){
            if(angular.isArray(parent)){
                $.each(parent, function(key, eachParent){
                    dirtyElms = $("'" + eachParent + ' ' + '.ng-dirty');
                    checkDirty(dirtyElms);
                    if(navAway){
                        return false; // Break out of each
                    }
                });
            }else{
                dirtyElms = $("'" + parent + ' ' + '.ng-dirty');
                checkDirty(dirtyElms);
            }
        }else{
            dirtyElms = $('.ng-dirty');
            checkDirty(dirtyElms);
        }

        if (navAway) {
            if (showConfirm) {
                return confirm(i18n.NAV_AWAY_WARNING_MESSAGE);
            }
            return i18n.NAV_AWAY_WARNING_MESSAGE;
        }


        function checkDirty(dirtyElms){
            $.each(dirtyElms, function(key, elem){
                // $(checkbox).val is always 'on' - avoiding that check.
                if($(elem).is(':checkbox') && $(elem).is(':checked')){
                    navAway = true;
                    return false; // Break out of each
                }else if(!$(elem).is(':checkbox') && $(elem).val().trim() !== ''){
                    navAway = true;
                    return false; // Break out of each
                }
            });
        }
    };


    /**
     * Highlights the active tab (styling only atm)
     * Checks if the path passed matches the current path ignores REST params
     *
     * @todo add code to ignore REST params. Use $location, may be in a separate file/module called locUtils or something which is injected the $location OR take hash as a param.
     * @returns {boolean}
     */
    $rootScope.activeTab = function(url){
        return (window.location.hash.indexOf(url) !== -1);
    };

    /**
     * Returns an object containing all the current url get params
     *
     * @return {Object}
     */
    $rootScope.urlParams = function() {
        var params = {},
        hash,
        length,
        hashes,
        start,
        stop;
        start = window.location.href.indexOf('?') + 1;
        stop = window.location.href.length - start - window.location.hash.length;
        hashes = window.location.href.substr(start, stop).split('&');
        length = hashes.length;
        while (length > 0, length--) {
            hash = hashes[length].split('=');
            if (hash[0]) {
                if (hash[1] === undefined) {
                    hash[1] = true;
                }
                params[hash[0]] = hash[1];
            }
        }
        return params;
    };

    /**
     * Populates the watched variable 'notice' with the message. Use 'notice' in html to toggle a element to display the message, message disappears after 3 secs.
     * If used with style 'msg-notice', a message is shown at the top of the page.
     * @param skipLookup If true, value of parameter 'code' is used as a direct message string that is shown.
     *                   If false, value of parameter 'code' is looked up in the global i18n variable.
     *
     * @param type Type of message, for ex: notice/error.
     *
     */
    $rootScope.showMsg = function(code, skipLookup, type) {
        type = type || 'notice';
        if (skipLookup){
            $rootScope[type] = code;
        } else if (i18n[type+'s'] && i18n[type+'s'][code]) {
            $rootScope[type]= i18n[type+'s'][code];
        }
    };

    $rootScope.showMsg($rootScope.urlParams().code);
    $rootScope.showMsg($rootScope.urlParams().error, false, 'error');
    if($rootScope.urlParams().adminCode) {
        $rootScope.showMsg($rootScope.i18n[$rootScope.urlParams().adminCode], true);
    }
    if($rootScope.urlParams().adminError) {
        $rootScope.showMsg($rootScope.i18n[$rootScope.urlParams().adminError], true);
    }

    /**
     * Clears the value of 'notice'(i18n token) after 5 seconds, which means the confirmation banner showing the 'notice'
     * disappears after 5 seconds.
     */

    $rootScope.$watch('notice', function(newVal, oldVal, scope){
        if (newVal) {
            $timeout(function(){
                $rootScope.notice = null;
            }, 5000);
        }
    });

    /**
     * Clears the value of 'error'(i18n token) after 10 seconds, which means the confirmation banner showing the 'error'
     * disappears after 10 seconds.
     */

    $rootScope.$watch('error', function(newVal){
        //added the temporary fix for not displaying message bar if the message is 'UNABLE_TO_PERFORM_OPERATION'
        if(i18n && newVal && newVal === i18n.UNABLE_TO_PERFORM_OPERATION) {
            $rootScope.error = null;
        } else if(newVal) {
            $timeout(function(){
                $rootScope.error = null;
            }, 10000);
        }
    });


    $rootScope.size = function(obj){
        var size, key;
        if(obj === null || typeof obj === 'undefined'){
            // Do Nothing
        }else if(angular.isObject(obj)){
            size = 0;
            for(key in obj){
                if(obj.hasOwnProperty(key)){
                    size++;
                }
            }
        }else if(angular.isArray(obj) || angular.isString(obj)){
            size = obj.length;
        }else if(typeof obj === 'number' || angular.isNumber(obj)){
            size = obj.toString().length;
        }

        return size;
    };


    /**
     * Wrapper for angular copy to be used in angular templates.
     */

    $rootScope.copy = function(source, destination){
        var args = Array.prototype.slice.call(arguments);
        return angular.copy.apply(angular, args);
    };


    /**
     * Filters all scaffolding properties added by angular.
     */
    $rootScope.filterNgScaffolding = function(obj){
        var attrs;

        if(!obj){
            return;
        }

        attrs =  ['$$hashKey'];
        angular.forEach(attrs, function(attr){
            if(obj.hasOwnProperty(attr)){
                delete obj[attr];
            }
        });

        return obj;
    };

    /**
     * Wrapper for encoding urls using the JS native method http://localhost:8080/TalentNetwork/person/applicants.html
     */
    $rootScope.encodeURI = function(uri){
        return encodeURIComponent(uri);
    };

    /**
     * An optional condensed mode for TinyMCE WYSIWYG
     */
    $rootScope.tinymceCompact = {
            theme_advanced_buttons1: 'undo,redo,seperator,justifyleft,justifycenter,justifyright,separator,bold,italic,underline,separator,bullist,numlist,link',
            theme_advanced_buttons2: 'formatselect,separator,imagepopup,table,separator,sub,sup,separator,code'
    };

    /**
     * Debugging Tools
     *
     * Allows you to execute debug functions from the view
     */
    $rootScope.log = function(variable) {
        if (window.console && console.log) {
            console.log(variable);
        }
    };

    $rootScope.alert = function(text) {
        alert(text);
    };

    $rootScope.isNumberValid = function (value) {
        if(value) {
            return isNaN(value.toString().replace(/[,.]/g, ''));
        } else {
            return false;
        }
    };
        /**
     * Sort object array wrt to any property in object
     * @param (property) : property in object
     * @returns function hence can be directly called as sort callback function
     * ex: fooObjArray=[{name:'bar'},{name:'dish'}]; fooObjArray.sort('name');
     */
    $rootScope.sortObjArrayByProperty = function(property) {
        var sortOrder = 1;
        if(property[0] === '-') {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a,b) {
            var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
            return result * sortOrder;
        };
    };
    /**
    * This will be useful to check for undefined condition on templates
    **/
    $rootScope.isUndefined = function(obj){
        return angular.isUndefined(obj);
    };

    $rootScope.isValidApplicationURL = function(url){
        var isValid = false;
        if(isRelativeUrl(url)){
            isValid = true;
        }else if(url && (url.indexOf('http')===0)) {
            url = unescape(url);
            try{
                var redirectHost = new URL(url).host.toLowerCase();
                var forumHost = new URL(window.jvUrls.forum).host.toLowerCase();
                var baseSourceHost = new URL(window.jvUrls.source).host.toLowerCase();
                if((redirectHost === forumHost || redirectHost === baseSourceHost)) {
                    isValid =true;
                }
            }catch(e){
                //exception is thrown when no valid URL can be formed from redirect, forum or source urlStrings.
            }  
        }
        return isValid;
    };
    function isRelativeUrl(url) {
        return url &&
            url.startsWith('/') &&
            !url.startsWith('//') &&
            !url.startsWith('/\\');
    }
    $rootScope.select2Options = uiTemplateSelect2FAC();
}]).config(['$provide', function($provide) {
    $provide.decorator('inputDirective', ['$delegate', function($delegate) {
        angular.forEach($delegate, function(linkDirective) {
            var _compile = linkDirective.compile;
            linkDirective.compile = function(element, attrs) {
                if (!attrs.uiSelect2) {
                    return _compile.apply(this, arguments);
                }
            };
        });
        return $delegate;
    }]);
}]).value('ui.config', {
    /**
     * AngularUI defaults can be declared here
     * Passing parameters to the directive or filter will still override these defaults
     *
     * To add a default, simply namespace the options by the name of the directive/filter (without ui prefix)
     * Any variable type can be passed
     *
     */
    select2: $.extend({}, {
        allowClear: true,
    }, window._jvPluginDefaults ? window._jvPluginDefaults.select2 : {}),
    date: {
        changeMonth: true,
        changeYear: true
    },
    tinymce: {
        inline_styles: false,
        theme: 'advanced',
        button_title_map: false,
        apply_source_formatting: true,
        //valid_elements : '-ul/-ol,-li',
        fix_list_elements : true,
        theme_advanced_statusbar_location : 'none',
        plugins: 'table,advimage,advlink,paste,fullscreen',
        theme_advanced_toolbar_align: 'left',
        theme_advanced_buttons1: 'formatselect,seperator,undo,redo,seperator,justifyleft,justifycenter,justifyright,separator,bold,italic,underline,separator,bullist,numlist,link,separator,imagepopup,table,separator,sub,sup,separator,code',
        theme_advanced_buttons2: '',
        theme_advanced_buttons3: '',
        theme_advanced_toolbar_location: 'top',
        theme_advanced_resizing : true,
        theme_advanced_blockformats : 'p,h2,h3,blockquote',
        forced_root_block : false,
        force_br_newlines : true,
        force_p_newlines : false,
        formats : {
            underline : { inline : 'u', exact : true }
        }
    },
    jq: {
        draggable: {

        },
        timepicker: {
            scrollDefaultNow: true
        }
    }
}).value('version', '0.1')
.constant('NOTE_MAX_LENGTH', 1024)
.factory('Model', ['parentModel', function(parentModel) {
    //construct the service instance
    function Model() {
        if (parentModel) {
            return Model.$parent.constructor.apply(this, arguments);
        }
    }
    if (parentModel) {
        Model.prototype.$parent = parentModel;
    }
    return Model;
}])
.filter('jvReplacePlaceholders', [function(){
    return function(patternStr){
        if (arguments.length > 1) {
            for (var i = 1; i < arguments.length; i++) {
                var pattern = '{' + (i-1) + '}';
                while (patternStr.indexOf(pattern) > 0) {
                    patternStr = patternStr.replace(pattern, arguments[i]);
                }
            }
        }
        return patternStr;
    };
}])
.factory('uiTemplateSelect2FAC', ['$filter', 'TextUtil', function ($filter, TextUtil) {
    return function(){
        var processTemplate= function(templatesData){
            var templates = [];
            if(angular.isArray(templatesData)){
                angular.forEach(templatesData, function(tpl) {
                    var template = {
                        eid: tpl.eid || tpl.EId,
                        body: tpl.body,
                        subject: tpl.subject,
                        title: tpl.title,
                        default: tpl.default || false,
                        isDefault: tpl.default || false,
                        locale: tpl.locale
                    };
                    templates.push(template);
                });
            }else{
                return {
                    eid: templatesData.eid || templatesData.EId || templatesData.SId,
                    body: templatesData.body,
                    subject: templatesData.subject,
                    title: templatesData.title || templatesData.name,
                    default: templatesData.default || false,
                    isDefault: templatesData.default || false
                };
            }
            return templates;
        };
        var setFirstAsDefault = function(_templates){
            var stopHere=-1;
            angular.forEach(_templates, function(template, index){
                if(stopHere !== -1){
                    template.default = false;
                    template.isDefault = false;
                }
                if(template.default || template.isDefault){
                    stopHere = index;
                }
            });
            //Set first template as default, if none is set
            if(stopHere === -1 && _templates.length){
                _templates[0].default = true;
                _templates[0].isDefault = true;
            }
            return _templates;
        };
        var templates = [];
        return{
            id: 'eid',
            query: function(query){
                var data = [];
                angular.forEach(templates, function(template, index){
                    if(template.length){
                        //Grouped Templates wrt. langugae
                        var searchResult = $filter('filter')(template, {'title': query.term });
                        if(searchResult.length){
                            data.push({
                                title: index,
                                children: processTemplate(searchResult)
                            });
                        }
                    }else{
                        //Template list with no grouping
                        if($filter('filter')([template], {'title': query.term }).length){
                            data.push(processTemplate(template));
                        }
                    }
                });
                query.callback({
                    results: data
                });
            },
            formatResult: function (item) {
                return TextUtil.htmlEncode(item.title);
            },
            formatSelection: function (item) {
                return item.title;
            },
            setTemplates: function(_templates){
                var _templatesCopy = [];
                if(angular.isDefined(_templates)){
                    templates = angular.copy(_templates);//initialize list
                    angular.forEach(_templates, function(template, index){
                        if(template && template.length){
                            _templatesCopy = _templatesCopy.concat(processTemplate(template));
                        }else{
                            _templatesCopy.push(processTemplate(template));
                        }
                    });
                    //Template should not be grouped when there is only 1 category exists!
                    if(Object.keys(_templates) &&  Object.keys(_templates).length === 1){
                        templates = angular.copy(_templatesCopy);
                    }
                }
                return setFirstAsDefault(_templatesCopy);
            }
        };
    };
}])
.factory('jvFormFieldDropDownValuesFAC',[function() {
    //FACTORY configures AjaxSelect2 control to fetch gield values as Select2 is rendering in ng-repeat and Every control will have diffrent URL
    return function(field, companyEId){
        return {
            url: (companyEId ? '/jhire/action/agency/field/'+companyEId+'/{0}/values?' : '/jhire/action/application/field/{0}/values?'),
            config: {
                initSelection: function(element, callback){
                    if(field && field.value && field.values) {
                        element.val(field.values[0]);
                        callback(field.values[0]);
                    }
                }
            }
        };
    };
}]);
